import type { Guide } from "./guide-types"
import { rateHistoryGuide } from "./guides/ato-cents-per-km-rate-history"
import { logbookRequirementsGuide } from "./guides/ato-logbook-requirements"
import { taxInvoiceRequirementsGuide } from "./guides/tax-invoice-requirements"

export const GUIDES: readonly Guide[] = [
  rateHistoryGuide,
  logbookRequirementsGuide,
  taxInvoiceRequirementsGuide,
]

export const getGuide = (slug: string): Guide | undefined => GUIDES.find((g) => g.slug === slug)
